<template>
  <div>
    <!--  搜索-->
    <div class="search">
      <!-- 主题关键词 -->
      {{ $t('message.topicKeyword') }}:
      <div class="item">
        <el-input v-model="datas.keyword">
        </el-input>
      </div>
      <!-- 状态 -->
      {{ $t('message.status') }}:
      <div class="item">
        <el-select v-model="datas.status">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <!-- 开始日期-->
      <div class="item">
        <el-date-picker v-model="datas.str_time" :placeholder="$t('message.startDate')" type="datetime"
          default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>
      <!--  结束日期-->
      <div class="item">
        <el-date-picker v-model="datas.end_time" :placeholder="$t('message.dateClosed')" default-time="['23:59:59']"
          type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>
      <div class="item">
        <!--  搜索 -->
        <el-button type="primary" @click="search">
          {{ $t("message.search") }}
        </el-button>
        <!--  重置 -->
        <el-button @click="reset">{{ $t("message.reset") }}</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <div class="table">
      <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
        :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" size="medium">
        <el-table-column align="center" label="NO" prop="rowNumber" width="45">
        </el-table-column>
        <!-- 邮件主题 -->
        <el-table-column align="center" label="NO" prop="Subject" :label="$t('message.mailTitle')">
        </el-table-column>
        <!-- 发送人 -->
        <!-- <el-table-column align="center" label="NO" prop="rowNumber" :label="$t('message.sender')" width="200">
        </el-table-column> -->
        <!-- 发送时间 -->
        <el-table-column align="center" label="NO" prop="insertTime" :label="$t('message.sendingTime')" width="200">
        </el-table-column>
        <!-- 状态 -->
        <el-table-column align="center" label="NO" prop="status" :label="$t('message.status')" width="200">
          <template slot-scope="scope">
            <p class="status">
              <span :class="{ inco: scope.row.status == '已查看' }"></span>{{ scope.row.status }}
            </p>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column align="center" label="NO" :label="$t('message.operation')" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="emailDetail(scope.row.id)">
              {{ $t('message.detail') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paginationContainer">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
        :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 邮件详情 -->
    <el-dialog :title="$t('message.mailDetails')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="888px" center>
      <div class="content">
        <div class="mailTitle">
          <div class="item">
            info@mail.rakumart.cn
          </div>
          <div class="item">
            2023-07-17 15:53:24
          </div>
        </div>
        <div class="main" v-html="detail.HtmlContent">
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    user_id: { type: Number },
  },
  data() {
    return {
      datas: {
        keyword: '',
        status: '',
        keyword: '',
        str_time: '',
        end_time: '',
        page: 1,
        pageSize: 10,
      },
      tableData: [],
      total: 0,
      dialogVisible: false,
      detail: {},
    };
  },
  computed: {
    options() {
      let option = [
        {
          label: this.$t('message.notViewed'),// 未查看
          value: '1',
        },
        {
          label: this.$t('message.viewed'),// 已查看
          value: '2',
        },
      ]
      return option
    }
  },
  created() {

  },
  methods: {
    // 邮件列表
    emailList() {
      this.datas.user_id = this.user_id
      this.$api.JapaneseOffice.emailList(this.datas).then(res => {
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    search() {
      this.datas.page = 1
      this.emailList()
    },
    reset() {
      this.datas = {}
      this.emailList()
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.emailList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.emailList();
    },
    //详情
    emailDetail(id) {
      this.$api.JapaneseOffice.emailDetail({ id }).then(res => {
        res.data.HtmlContent = res.data.HtmlContent.replaceAll('br', '<br/>',)
        res.data.HtmlContent = res.data.HtmlContent.replaceAll('p', '<p>',)
        res.data.HtmlContent = res.data.HtmlContent.replaceAll('\n', '<br/>',)
        this.detail = res.data
        this.dialogVisible = true
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  margin-top: 12px;
  line-height: 40px;

  .item {
    margin-right: 24px;
  }
}

.table {
  margin: 24px 0;

  /deep/.el-table__cell .cell {
    padding: 0 5px;
  }
}

a {
  color: #b4272d;

  &:hover {
    text-decoration: underline;
  }
}

.content {
  padding: 0 30px;
  height: 500px;
  overflow-y: auto;

  .mailTitle {
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
  }


}

.status {
  span {

    display: inline-block;
    width: 8px;
    height: 8px;
    margin-right: 8px;
    border-radius: 50%;
    background: #D5D5D5;
  }

  .inco {

    background: #1DC198;
  }

}
</style>